export default function replaceAllBracketedStrings(template, replacement) {
    return template?.replace(/\[([^\]]+)\]/g, (match, p1) => {
        // Extract the index from the placeholder
        let index = 0;
        if (template.includes('storenr')) {
            index = ['storenr', 'letter'].indexOf(p1)
        } else {
            index = ['discount', 'storename', 'monthyear'].indexOf(p1)
        }
        // Replace with the corresponding value if index is valid


        return index !== -1 && replacement ? replacement[index] : match;
    });
}

export function replaceBracketToString(input, replacement) {
    const items = input?.match(/\[.*?\]/g);

    if (Array.isArray(items)) {
        items.forEach((e, index) => {
            input = input?.replace(e, replacement[index]);
        });
    }

    return input;
}


export function replaceSingleBracketWithString(input, replacement) {
    return input?.replace(/\[.*?\]/, replacement)
}

export function isLetter(char) {
    // Regular expression to match a single letter (a-z, A-Z)
    const regex = /^[a-zA-Z]$/;

    // Test if the given character matches the regex
    return regex.test(char);
}